import React from 'react';

type Props = {
  color?: string;
};

export const GoogleIcon: React.FC<Props> = ({ color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_google)">
        <path
          d="M23.7663 12.2765C23.7663 11.4608 23.7001 10.6407 23.559 9.83819H12.2402V14.4592H18.722C18.453 15.9495 17.5888 17.2679 16.3233 18.1057V21.104H20.1903C22.4611 19.014 23.7663 15.9275 23.7663 12.2765Z"
          fill={color || '#4285F4'}
        />
        <path
          d="M12.2401 24.0009C15.4766 24.0009 18.2059 22.9382 20.1945 21.1039L16.3276 18.1056C15.2517 18.8375 13.8627 19.252 12.2445 19.252C9.11388 19.252 6.45946 17.1399 5.50705 14.3003H1.5166V17.3913C3.55371 21.4435 7.7029 24.0009 12.2401 24.0009Z"
          fill={color || '#34A853'}
        />
        <path
          d="M5.50277 14.3003C5.00011 12.8099 5.00011 11.1961 5.50277 9.70571V6.61475H1.51674C-0.185266 10.0056 -0.185266 14.0004 1.51674 17.3912L5.50277 14.3003Z"
          fill={color || '#FBBC04'}
        />
        <path
          d="M12.2401 4.74966C13.9509 4.72321 15.6044 5.36697 16.8434 6.54867L20.2695 3.12262C18.1001 1.08551 15.2208 -0.0344645 12.2401 0.000810969C7.7029 0.000810969 3.55371 2.55822 1.5166 6.61481L5.50264 9.70577C6.45064 6.86173 9.10947 4.74966 12.2401 4.74966Z"
          fill={color || '#EA4335'}
        />
      </g>
      <defs>
        <clipPath id="clip0_google">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
